import { render, staticRenderFns } from "./assetSwitch.vue?vue&type=template&id=2e8211a9&"
import script from "./assetSwitch.vue?vue&type=script&lang=js&"
export * from "./assetSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8211a9')) {
      api.createRecord('2e8211a9', component.options)
    } else {
      api.reload('2e8211a9', component.options)
    }
    module.hot.accept("./assetSwitch.vue?vue&type=template&id=2e8211a9&", function () {
      api.rerender('2e8211a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/assetSwitch.vue"
export default component.exports